import reducer from './instrumentsReducer';
import * as selectors from './selectors';

export default reducer;
export { selectors };
